import * as React from "react";
import { TransactionHistory } from "../types";
import { Link } from "react-router-dom";
import { TopupService } from "../services/topup-service";
import classNames from "classnames";
import { formatDate } from "../utils";
import { MyAccountService } from "../myaccount/myaccount-service";
import { messageDialog } from "../dialogs/MessageDialog";
import { dialogService } from "react-api-dialog";
import t from "../i18n";
import { cardStyles } from "../_styles/receiptcard";
import { css } from "emotion";
import { ProductCategory } from "../types-enums";

declare type TrxBlockProps = {
    trx: TransactionHistory,
    onRepeat: (sessionId: string, category: ProductCategory) => void
}
export default class TrxBlock extends React.Component<TrxBlockProps> {
    repeat = async (doRepeat: boolean) => {
        if (!doRepeat) return;
        dialogService.showPreloader();
        const response = await MyAccountService.saveSessionByTransactionId(this.props.trx.transactionId);
        await dialogService.hidePreloader();
        if (!response) return;
        if (response.responseCode !== 0) {
            messageDialog(response.responseMessage || "", t.topup("repeat_transaction"));
            return;
        }
        if (!response.payLoad) return;
        const sessionId = response.payLoad.session.sessionId;
        const category = response.payLoad.session.productCategory!;
        if (this.props.onRepeat) this.props.onRepeat(sessionId, category);
    }
    renderTopup() {
        const trx = this.props.trx;
        if(trx.productCategory == ProductCategory.GiftCard) return null;
        return (
            <div>
                <div style={{marginBottom: 5}} >{trx.topupAmount} {trx.sourceCurrencyCode}</div>
                <div>
                    <i className="fa fa-user" />
                    <span style={{ marginLeft: 5 }}>+{trx.internationalCountryCode} {trx.mobileNumber}</span>
                </div>
            </div>
        );
    }
    renderGiftCard() {
        const trx = this.props.trx;
        if(trx.productCategory != ProductCategory.GiftCard) return null;
        return (
            <div>
                <div style={{marginBottom: 5}}>{`${trx.operator} Gift Card`} - {trx.topupAmount} {trx.sourceCurrencyCode}</div>
                <div>
                    <i className="fa fa-user" />
                    <span style={{ marginLeft: 5 }}>{trx.recipientEmail}</span>
                </div>
            </div>
        );
    }
    render() {
        const trx = this.props.trx;
        const trxStatus = TopupService.getTransactionStatus(trx);
        const cls = trxStatus === "success" ? "default" : trxStatus === "pending" ? "yellow" : "white";
        const allowRepeat = trxStatus === "success";
        const successJsx = <i className="fa fa-check" />;
        const nonSuccessJsx = trxStatus === "failed" ? t.topup("failed") : trxStatus === "pending" ? t.topup("pending") : trxStatus;

        return (
            <div className="form-group col-sm-6">
                <div className="d-flex align-items-center justify-content-between" style={{ color: "#999999" }}>
                    <div>{formatDate(trx.transactionDate)}</div>
                    <div>{t.receipt("net_charge")}: {trx.netCharge} {trx.sourceCurrencyCode}</div>
                </div>
                <div className={classNames(["receipt-card", css(cardStyles[cls])])}>
                    <div className="d-flex align-items-center justify-content-between">
                       {this.renderTopup()}
                       {this.renderGiftCard()}
                        <div>
                            <a href="javascript: void(0)" onClick={() => this.repeat(allowRepeat)}
                                className={classNames({ button: true, disabled: !allowRepeat })}>
                                {t.topup("repeat_button_title")}
                            </a>
                        </div>
                    </div>
                    <hr />
                    <div className="d-flex align-items-center justify-content-between">
                        <div>
                            <Link className="link trx-id-label" to={`/receipt?transactionId=${trx.transactionId}`}>
                                {t.topup("transaction_id", { transactionId: trx.transactionId })}
                            </Link>
                        </div>
                        <div style={{ textTransform: "uppercase" }}>{trxStatus === "success" ? successJsx : nonSuccessJsx}</div>
                    </div>
                </div>
            </div>
        );
    }
}
